export default __webpack_public_path__ + "static/media/spinner.1708de7d.gif";